var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{attrs:{"id":"Form__logout","action":"/logout","method":"post"}},[_c('input',{attrs:{"name":"_token","type":"hidden"},domProps:{"value":_vm.csrfToken}}),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.logout()}}},[_vm._v("Logout")])])
}
var staticRenderFns = []

export { render, staticRenderFns }